export function obterListaCteModeloNfProdutor() {
  return (
    [
      { label: 'Nenhuma', value: '' },
      { label: 'Avulsa', value: 'AVULSA' },
      { label: 'Produtor Rural', value: 'PRODUTORRURAL' },
    ]
  );
}
